<user-change-password *ngIf="isUserRetrieved && isPwToChange" [user] = "user" (onChangePassword)="onChangePassword()"></user-change-password>
<confirm-user *ngIf="!isConfirmed && isUserRetrieved && isTenantsRetrieved && !isNoTenantAssigned" [user] = "user" [userTenants] = "userTenants" [showProfile] = false (onChangeUser)="onChange(user)"></confirm-user>
<select-tenant *ngIf="isConfirmed"></select-tenant>
<div *ngIf="isNoTenantAssigned">
    <br><br>
    <span style="padding-left:20px"><b>Kein Mandant und keine Projekte mehr zugeordnet!</b></span>
</div>

